import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import Spacer from '../../Spacer';

const Name = styled.div<{ selected?: boolean; selectable: boolean }>`
  font-weight: ${(props) => (props.selectable ? 500 : 300)};
  color: ${(props) =>
    props.selected || !props.selectable ? '#171C3C' : `#9092C1`};
`;

const Container = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: 20px 37px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.1s;
  position: relative;
`;

const BarContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  bottom: -2px;
  left: 0px;
  justify-content: center;
`;

const SelectedBar = styled.div`
  border-radius: 6px;
  height: 2px;
  background: #5d6ef8;
  width: 100%;
  animation-name: example;
  animation-duration: 0.3s;
  @keyframes example {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
`;

type Props = {
  children?: React.ReactNode;
  fontawesomeIcon?: {
    icon: IconDefinition;
    color: string;
  };
  icon?: React.ReactNode;
  onClick?: () => void;
  selected?: boolean;
  selectable?: boolean;
};

export function MenuItem({
  icon,
  fontawesomeIcon,
  children,
  onClick,
  selected,
  selectable = true,
}: Props) {
  return (
    <Container onClick={() => onClick && onClick()} selected={selected}>
      {fontawesomeIcon && (
        <FontAwesomeIcon
          icon={fontawesomeIcon.icon}
          color={selectable ? fontawesomeIcon.color : '#171C3C'}
          size={'xs'}
        />
      )}
      {icon && icon}
      <Spacer horizontal spacing={1} />
      <Name selected={selected} selectable={selectable}>
        {children}
      </Name>
      {selected && (
        <BarContainer>
          <SelectedBar />
        </BarContainer>
      )}
    </Container>
  );
}
